"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module("models").service("ApiService", ["$rootScope", "$state", "SERVER_NX_URL", function ($rootScope, $state, SERVER_NX_URL) {
  var _this = this;

  var that = this;

  that.debug = debug("model:apiService");

  that.debug("ApiClient url = " + SERVER_NX_URL);

  that.apiClient = new ApiClient(SERVER_NX_URL, $rootScope);

  that.login = function (credential) {
    return that.apiClient.login(credential);
  };

  that.setToken = function (token) {
    return that.apiClient.setToken(token);
  };

  that.getToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", that.apiClient.getToken());

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  that.generateMobileToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var model, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            model = that.apiClient.getModel("auth");
            _context2.next = 3;
            return model.get("auth/mobile-token");

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response.token);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  that.setCookieFromToken = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(token) {
      var model;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              model = that.apiClient.getModel("auth");
              return _context3.abrupt("return", model.post("auth/set-cookie", { token: token }));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  that.getModelBis = function (params) {
    var _this2 = this;

    var model = that.apiClient.getModel(params.customPath ? params.customPath : params.name);

    that.debug("create model for ", params.name);

    if (params.attributesForCache) {
      params.attributesForCache.push("_id");

      model.attributesForCache = params.attributesForCache;

      model.cacheInfo = {};

      model.clearCache = function () {
        that.debug("clear cache for " + params.name);
        model.cacheArray = null;
        model.objectsForName = null;
      };

      model.checkCacheInfo = function () {
        that.debug("check cache for " + params.name, model.cacheInfo.customerId === $rootScope.$selectedCustomerId);

        that.debug("check cache for " + params.name, model.cacheInfo.customerId, $rootScope.$selectedCustomerId);

        if (model.cacheInfo && model.cacheInfo.customerId === $rootScope.$selectedCustomerId) {} else {
          model.cacheInfo.customerId = $rootScope.$selectedCustomerId;

          that.debug("clear cache !!! for " + params.name + ("[" + $rootScope.$selectedCustomerId + "]"));
          model.cacheArray = null;
          model.objectsForName = null;
        }
      };

      model.getSelectArray = function () {
        var withInactive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        return new Promise(function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(resolve, reject) {
            var _array, objectMap, array, _id, element, name;

            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.prev = 0;

                    model.checkCacheInfo();

                    if (!model.cacheArray) {
                      _context4.next = 6;
                      break;
                    }

                    resolve(model.cacheArray && model.cacheArray.length > 0 ? model.cacheArray.filter(function (group) {
                      return withInactive || !group.inactive || group.inactive == false;
                    }) : []);
                    _context4.next = 25;
                    break;

                  case 6:
                    if (!(model.objectsForName == null)) {
                      _context4.next = 20;
                      break;
                    }

                    that.debug("getSelectArray no cache for " + params.name);

                    _array = [];

                    if (!params.loadCache) {
                      _context4.next = 15;
                      break;
                    }

                    _context4.next = 12;
                    return params.loadCache();

                  case 12:
                    _array = _context4.sent;
                    _context4.next = 18;
                    break;

                  case 15:
                    _context4.next = 17;
                    return model.load(model.attributesForCache);

                  case 17:
                    _array = _context4.sent;

                  case 18:
                    objectMap = _array.reduce(function (map, obj) {
                      map[obj._id] = obj;
                      return map;
                    }, {});


                    model.objectsForName = objectMap;

                  case 20:
                    array = [];


                    for (_id in model.objectsForName) {
                      element = model.objectsForName[_id];
                      name = params.formatName(element);


                      array.push({
                        name: name,
                        value: "$" + element._id,
                        inactive: element.inactive
                      });
                    }

                    model.cacheArray = array;

                    that.debug("$$$ model.cacheArray=", model.cacheArray);

                    resolve(array.filter(function (group) {
                      return !group.inactive || group.inactive == false;
                    }));

                  case 25:
                    _context4.next = 31;
                    break;

                  case 27:
                    _context4.prev = 27;
                    _context4.t0 = _context4["catch"](0);

                    that.debug(_context4.t0);
                    resolve("?.?");

                  case 31:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, _this2, [[0, 27]]);
          }));

          return function (_x3, _x4) {
            return _ref4.apply(this, arguments);
          };
        }());
      };

      model.getById = function (idYourAreLookingFor) {
        that.debug(params.name + " getById for " + idYourAreLookingFor);

        return new Promise(function () {
          var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(resolve, reject) {
            var array, lvrUsers, objectMap, element;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.prev = 0;

                    if (!(!idYourAreLookingFor || idYourAreLookingFor.length < 24)) {
                      _context5.next = 6;
                      break;
                    }

                    that.debug("wrong _id format");
                    resolve("?.?");
                    _context5.next = 27;
                    break;

                  case 6:
                    model.checkCacheInfo();

                    if (!(model.objectsForName == null)) {
                      _context5.next = 26;
                      break;
                    }

                    that.debug("getById no cache for " + params.name);

                    array = [];

                    if (!params.loadCache) {
                      _context5.next = 16;
                      break;
                    }

                    _context5.next = 13;
                    return params.loadCache();

                  case 13:
                    array = _context5.sent;
                    _context5.next = 19;
                    break;

                  case 16:
                    _context5.next = 18;
                    return model.load(model.attributesForCache);

                  case 18:
                    array = _context5.sent;

                  case 19:
                    if (!(model.name == "users" && ["super-admin", "super-operator", "operator"].includes($rootScope.$user.role))) {
                      _context5.next = 24;
                      break;
                    }

                    _context5.next = 22;
                    return model.find({
                      filter: {
                        where: {
                          customerId: "$592e962acef2545fb62f1a99"
                        },
                        fields: {
                          // Tous les attributs sont à mettre ici pour que la fiche récap. fonctionne
                          lastName: true,
                          firstName: true,
                          internalNumber: true,
                          _id: true,
                          customerId: true,
                          trueInternalNumber: true,
                          email: true,
                          cellularPhone: true,
                          phone: true,
                          defaultManagerId: true,
                          rhManagerId: true,
                          qseManagerId: true,
                          fleetManagerId: true,
                          other1ManagerId: true,
                          other2ManagerId: true,
                          defaultManagerIdIsAutoFilled: true,
                          rhManagerIdIsAutoFilled: true,
                          qseManagerIdIsAutoFilled: true,
                          fleetManagerIdIsAutoFilled: true,
                          other1ManagerIdIsAutoFilled: true,
                          other2ManagerIdIsAutoFilled: true,
                          groupsId: true,
                          usersEmailsCcId: true,
                          typeVehicles: true,
                          contract: true,
                          yearOfBirth: true,
                          startDate: true,
                          endDate: true,
                          endBlockDate: true,
                          creationDate: true,
                          lastUserModificationDate: true,
                          importDate: true,
                          importBy: true,
                          updateDate: true,
                          updateBy: true,
                          active: true,
                          positions: true,
                          positionTitle: true,
                          areaName: true,
                          departmentName: true,
                          licenceValidityDate: true,
                          role: true,
                          rights: true,
                          onlyMerchandise: true,
                          canLoginToBeta: true,
                          isVirtual: true,
                          isVisibleByEveryone: true,
                          toCheck: true,
                          externalCompany: true,
                          "nbElearnings.short": true,
                          "nbElearnings.long": true,
                          nbDamages: true,
                          nbAccidents: true,
                          nbMissingDepas: true,
                          nbDepas: true,
                          nbCourses: true,
                          lastDamageDate: true,
                          lastDepaDate: true,
                          lastCourseDate: true,
                          nbDispute0: true,
                          nbDispute50: true,
                          nbDispute100: true,
                          note: true,
                          creationUserId: true
                        }
                      }
                    });

                  case 22:
                    lvrUsers = _context5.sent;

                    array = [].concat(_toConsumableArray(array), _toConsumableArray(lvrUsers));

                  case 24:
                    objectMap = array.reduce(function (map, obj) {
                      map[obj._id] = obj;
                      return map;
                    }, {});


                    model.objectsForName = objectMap;

                  case 26:

                    if (idYourAreLookingFor && typeof idYourAreLookingFor === "string") {
                      idYourAreLookingFor = idYourAreLookingFor.replace(/[$]/g, "");

                      element = model.objectsForName[idYourAreLookingFor];


                      if (!element) {
                        that.debug("element " + idYourAreLookingFor + " not foud in cache for " + params.name);
                        element = {
                          _id: idYourAreLookingFor,
                          error: 404,
                          inactive: true
                        }; // inactive -> group -> hidden in the list of groups
                        model.objectsForName[idYourAreLookingFor] = element;
                      }

                      resolve(element);
                    } else {
                      resolve("???");
                    }

                  case 27:
                    _context5.next = 33;
                    break;

                  case 29:
                    _context5.prev = 29;
                    _context5.t0 = _context5["catch"](0);

                    that.debug("add empty obj 2", _context5.t0);
                    resolve("?.?");

                  case 33:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, _this2, [[0, 29]]);
          }));

          return function (_x5, _x6) {
            return _ref5.apply(this, arguments);
          };
        }());
      };

      model.getNameWithEmailById = function (idYourAreLookingFor) {
        that.debug(params.name + " getNameWithEmailById " + idYourAreLookingFor);
        return new Promise(function () {
          var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(resolve, reject) {
            var element, name;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.prev = 0;
                    _context6.next = 3;
                    return model.getById(idYourAreLookingFor);

                  case 3:
                    element = _context6.sent;

                    if (element) {
                      name = params.formatName(element);

                      if (element.email) {
                        name += " - <a href='mailto:" + element.email + "'/>" + element.email + "</a>";
                      }
                    } else {
                      name = "?-?";
                    }

                    resolve(name);
                    _context6.next = 12;
                    break;

                  case 8:
                    _context6.prev = 8;
                    _context6.t0 = _context6["catch"](0);

                    that.debug(_context6.t0);
                    resolve("?.?");

                  case 12:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, _this2, [[0, 8]]);
          }));

          return function (_x7, _x8) {
            return _ref6.apply(this, arguments);
          };
        }());
      };

      model.getNameById = function (idYourAreLookingFor) {
        that.debug(params.name + " getNameById " + idYourAreLookingFor);
        return new Promise(function () {
          var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(resolve, reject) {
            var element, name;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.prev = 0;
                    _context7.next = 3;
                    return model.getById(idYourAreLookingFor);

                  case 3:
                    element = _context7.sent;


                    if (element) {
                      name = params.formatName(element);
                    } else {
                      name = "?-?";
                    }

                    resolve(name);
                    _context7.next = 12;
                    break;

                  case 8:
                    _context7.prev = 8;
                    _context7.t0 = _context7["catch"](0);

                    that.debug(_context7.t0);
                    resolve("?.?");

                  case 12:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7, _this2, [[0, 8]]);
          }));

          return function (_x9, _x10) {
            return _ref7.apply(this, arguments);
          };
        }());
      };
    } else {
      that.debug("no params.attributesForCache", params);
    }

    model.load = function (fields, sort, limit, where) {
      that.debug("load " + params.name, fields, sort, limit, where);

      if (typeof sort === "undefined") {
        sort = true;
      }

      return new Promise(function (resolve, reject) {
        var query = {
          filter: {
            where: where ? where : {}
          }
        };

        if (limit) {
          query.filter.limit = limit;
        }

        if (params.defaultOrder) {
          query.filter.order = params.defaultOrder;
        }

        if (fields) {
          query.filter.fields = {};

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var field = _step.value;

              query.filter.fields[field] = true;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        var globalModel = ["customers", "roles", "customLists"];

        if (globalModel.indexOf(params.name) == -1) {
          query.filter.where.customerId = $rootScope.$selectedCustomerId;
        }

        model.find(query).then(function (array) {
          that.debug("load before sort", array);

          that.debug("load fields", fields);

          if (fields && array && sort === true) {
            array = array.sort(function (a, b) {
              if (fields[0] && a[fields[0]] && b[fields[0]]) {
                return String(a[fields[0]]).localeCompare(String(b[fields[0]]), undefined, {
                  sensitivity: "base"
                });
              } else {
                return a > b;
              }
            });
          }

          that.debug("load after sort", array);

          resolve(array);
        }).catch(function (err) {
          that.debug(err);
          reject(err);
        });
      });
    };

    return model;
  };

  that.getModel = function (name, attributesForCache, formatName) {
    return that.getModelBis({
      name: name,
      attributesForCache: attributesForCache,
      formatName: formatName
    });
  };
}]);